import React from "react";
import {
  Search, Cpu, FileText, LineChart, BadgeCheck, AlertTriangle,
  Activity, ShieldCheck, ClipboardCheck, Users, DoorOpen, ArrowRight,
} from "lucide-react";

export default function DiligenceEngine() {
  const nodes = [
    { icon: Search, label: "Company lookup" },
    { icon: Cpu, label: "Profile auto-fill" },
    { icon: FileText, label: "Manual fallback" },
    { icon: FileText, label: "Document upload" },
    { icon: LineChart, label: "Financial extraction" },
    { icon: BadgeCheck, label: "Confidence labels" },
    { icon: AlertTriangle, label: "Red flag detection" },
    { icon: Activity, label: "Health Check" },
    { icon: ShieldCheck, label: "Trust Score" },
    { icon: ClipboardCheck, label: "DD Report" },
    { icon: Users, label: "Investor visibility" },
    { icon: DoorOpen, label: "Deal Room" },
  ];
  return (
    <section id="diligence" className="relative py-16 lg:py-20 overflow-hidden" data-testid="diligence-section"
              style={{ background: "linear-gradient(180deg, #082B20 0%, #0F3D2E 100%)" }}>
      <div aria-hidden="true" className="absolute inset-0 opacity-[0.04]" style={{
        backgroundImage: "linear-gradient(rgba(255,255,255,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.6) 1px, transparent 1px)",
        backgroundSize: "40px 40px",
      }} />
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-8">
          <div className="text-[11px] font-mono uppercase tracking-[0.2em] text-gold mb-3">DILIGENCE ENGINE</div>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-[42px] leading-tight text-cream">
            Diligence starts before the first investor conversation.
          </h2>
          <p className="mt-4 text-sm sm:text-base" style={{ color: "rgba(246,244,239,0.75)" }}>
            VENTURAZ turns onboarding, documents, financials, red flags, and review notes into structured investor-ready intelligence.
          </p>
        </div>

        <div className="flex flex-wrap items-center gap-2 -mx-1">
          {nodes.map(({ icon: Icon, label }, i) => (
            <React.Fragment key={label}>
              <div className="inline-flex items-center gap-2 px-3 py-2 rounded border border-white/15 bg-white/[0.04] text-cream text-[12px] font-mono hover:border-gold hover:bg-gold/[0.06] transition-colors">
                <Icon size={12} className="text-gold" />
                {label}
              </div>
              {i < nodes.length - 1 && (
                <ArrowRight size={12} className="text-white/25 hidden md:inline" />
              )}
            </React.Fragment>
          ))}
        </div>

        <p className="mt-8 text-sm max-w-3xl" style={{ color: "rgba(246,244,239,0.7)" }}>
          VENTURAZ does not rely only on founder-declared information. Every material company and financial data point can carry a source, confidence label, verification status, and investor-visibility control.
        </p>
      </div>
    </section>
  );
}
